import React from "react";
import { vibesColors as colors } from "../../theme/vibesColors";
import { EVENT_CATEGORY_TABS } from "../../constants/clubConstants";

export default function EventCategoryTabs({ activeKey, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
        marginTop: 0,
        padding: "10px 12px",
        background: "rgba(12, 0, 24, 0.9)",
        borderRadius: 16,
        border: `1px solid ${colors.violate}33`,
      }}
    >
      {EVENT_CATEGORY_TABS.map((t) => {
        const active = activeKey === t.key;
        return (
          <button
            key={t.key}
            type="button"
            onClick={() => onChange(t.key)}
            style={{
              flex: "1 1 auto",
              minWidth: "fit-content",
              padding: "10px 14px",
              borderRadius: 999,
              border: active ? "none" : `1px solid ${colors.violate}55`,
              background: active ? colors.BtnBackground : "transparent",
              color: colors.white,
              fontWeight: 600,
              fontSize: "0.88rem",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
